// extracted by mini-css-extract-plugin
module.exports = {"block":"e_us","lead":"e_vs","faces":"e_ws","face":"e_xs","plus":"e_ys","copy":"e_zs","title":"e_As","text":"e_Bs","button":"e_Cs","buttonIcon":"e_Ds"};